<script setup>
defineEmits(["redirectToConditions", "redirectToHelp"]);
</script>

<template>
    <div class="flex flex-col w-full px-10">
        <div class="flex gap-2 py-1 items-start justify-center w-full">
            <IconInfoCircle
                is-solid
                class="size-4 text-button-secondary-neutral-hover"
            />
            <span
                class="text-button-secondary-neutral-hover text-[11px] font-normal leading-[13px] w-full"
            >
                {{ $t("simulation.charge.legal_notice.message") }}
            </span>
        </div>
        <div
            class="flex flex-col py-4 gap-2 w-full items-center justify-center cursor-pointer"
        >
            <span
                data-testid="legal-notice-conditions"
                class="p-0.5 text-light-blue-700 text-[13px] font-semibold leading-4"
                @click="$emit('redirectToConditions')"
            >
                {{ $t("simulation.charge.legal_notice.conditions") }}
            </span>
            <span
                data-testid="legal-notice-help"
                class="p-0.5 text-light-blue-700 text-[13px] font-semibold leading-4 cursor-pointer"
                @click="$emit('redirectToHelp')"
            >
                {{ $t("simulation.charge.legal_notice.help") }}
            </span>
        </div>
    </div>
</template>
